'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$ConfigureTwoFactorAuthToCredential(tfa, kind, credentials) {
  this.Lw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.Lv = null;
  this.Lu = null;
  this.Lw = tfa;
  this.Lv = kind;
  this.Lu = credentials;
}
export { $c_Lpresto_types$proto$ConfigureTwoFactorAuthToCredential as $c_Lpresto_types$proto$ConfigureTwoFactorAuthToCredential };
$p = $c_Lpresto_types$proto$ConfigureTwoFactorAuthToCredential.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$ConfigureTwoFactorAuthToCredential;
/** @constructor */
function $h_Lpresto_types$proto$ConfigureTwoFactorAuthToCredential() {
}
export { $h_Lpresto_types$proto$ConfigureTwoFactorAuthToCredential as $h_Lpresto_types$proto$ConfigureTwoFactorAuthToCredential };
$h_Lpresto_types$proto$ConfigureTwoFactorAuthToCredential.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("ConfigureTwoFactorAuthToCredential"));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.Lw;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().br(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.Lv));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.Lu));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().al(acc, 3);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$proto$ConfigureTwoFactorAuthToCredential)) {
    var this$1 = this.Lw;
    var b = x$0.Lw;
    if (((this$1.e === b.e) && (this$1.f === b.f))) {
      var x = this.Lv;
      var x$2 = x$0.Lv;
      var $x_1 = (x === x$2);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lu;
      var x$4 = x$0.Lu;
      return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "ConfigureTwoFactorAuthToCredential";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.Lw;
      break;
    }
    case 1: {
      return this.Lv;
      break;
    }
    case 2: {
      return this.Lu;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$proto$ConfigureTwoFactorAuthToCredential(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kG)));
}
export { $isArrayOf_Lpresto_types$proto$ConfigureTwoFactorAuthToCredential as $isArrayOf_Lpresto_types$proto$ConfigureTwoFactorAuthToCredential };
var $d_Lpresto_types$proto$ConfigureTwoFactorAuthToCredential = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$ConfigureTwoFactorAuthToCredential, "presto.types$proto$ConfigureTwoFactorAuthToCredential", ({
  kG: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$ConfigureTwoFactorAuthToCredential as $d_Lpresto_types$proto$ConfigureTwoFactorAuthToCredential };
//# sourceMappingURL=presto.types$proto$-Configure-Two-Factor-Auth-To-Credential.js.map
